import React, { Component } from "react";

import "./Footer.scss"

class Footer extends Component {
  render() {
    return (
      <footer>
        <div id="footer">
          {!this.props.isArticle ?
            <div className="images-wrapper">
              <div className="image-r"></div>
              <div className="image-l"></div>
            </div>
            : ""}
          <div className="padding">
            <a href="//www.yit.co.il" title="YIT" target="_blank" rel="noopener noreferrer">
              <div className="yitlogo"></div>
            </a>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js